import React from "react";
import Container from "../../../../components/Container";
// import DataTable from "../../../../components/DataTable";
import DataTable from "../../DataTable";

// import styles from "./ImdmMembershipHistory.module.scss";
import styles from "../MembershipHistory.js/MembershipHistory.module.scss";

const ImdmMembershipHistory = ({ data }) => {
  const columns = [
    { accessor: "lastUpdated", Header: "Last Updated Date" },
    { accessor: "OldGoldenId", Header: "Old Golden ID" },
    { accessor: "NewGoldenId", Header: "New Golden ID" },
    { accessor: "actor", Header: "Actor" }
  ];
  return (
    <Container className={styles.base}>
      {data ? (
        <DataTable
          columns={columns}
          data={data}
          hasHover={false}
          isStripped={false}
          getHeaderProps={() => ({
            style: {
              backgroundColor: "#fff"
            }
          })}
        ></DataTable>
      ) : (
        <div className={styles.noDetails}>
          {"No Imdm Membership History found"}
        </div>
      )}
    </Container>
  );
};

export default ImdmMembershipHistory;
